import React from 'react';

type TreeDVistaProps = {
    url3DVista: string;
    messageTo3DVistaRef: any;
    onMessageReceivedFrom3DVista: (value: string) => void;
};

const TreeDVistaConnector: React.FC<TreeDVistaProps> = ({ url3DVista, messageTo3DVistaRef, onMessageReceivedFrom3DVista}) => {

  const iframeRef = React.useRef<HTMLIFrameElement>(null);

  const GetMessageFromIframe = React.useCallback((event: MessageEvent) => {
    if (event.origin !== window.origin){
      console.error("React: Mensaje de un origen distinto")
      return;
    }
    onMessageReceivedFrom3DVista(event.data);
  }, [onMessageReceivedFrom3DVista]);

  React.useEffect(() => {
    window.addEventListener('message', GetMessageFromIframe);
    return () => {
      window.removeEventListener('message', GetMessageFromIframe);
    };
  }, [GetMessageFromIframe]);

  const SendMessageToIframe = React.useCallback((type: string, data: any) => {
    if(!type || !data || data.length === 0)
      return;
    const iframeWindow = iframeRef.current?.contentWindow as any;
    if(!iframeWindow)
      return;
    if(!iframeWindow.blazeIT)
      return;
   
    
    if(type === 'location'){
      const viewModel = iframeWindow.blazeIT.getMediaByName(data);
      if (!!viewModel) {
        iframeWindow.blazeIT.openMedia(viewModel);
      }
    }

    if(type === 'hotspots'){
      //console.group("Hotspots Disponibles");
      const hotspots = iframeWindow.blazeIT.getAllHotspots();
      for(const hotspot of hotspots){
        if(hotspot.data.label.toLowerCase().includes("goto"))
          continue;
        let enabled = false;
        for(const message of data){
          if(hotspot.data.label.toLowerCase() === message.toLowerCase()){
            enabled = true;
            break;
          }
        }
        //console.log(hotspot.data.label, enabled);
        hotspot.set("enabled", enabled);
      }
      //console.groupEnd();
      console.log("hotspot activado: ", data);
      //iframeWindow.blazeIT.triggerHotspotByName(message, "click");
    }
  }, []);

  React.useImperativeHandle(messageTo3DVistaRef, () => ({
    SendMessage: SendMessageToIframe,
  }));

  return (
    <div className={`threedvista-full-container`}>
      <iframe ref={iframeRef} title='pc'
        className={`threedvista-container ${true ? 'visible' : ''}`}
        src={`${url3DVista}`}
        allow={`fullscreen; microphone; scrolling='no' frameborder='0';`}
      />
    </div>
  );
}

export default TreeDVistaConnector;